import React, { useEffect, useMemo, useState } from "react";
import {
  ResultRowContainer,
  ResultHeader,
  ResultPanelStyle,
  ResultFooter,
  TableContainer,
  TableStyled,
} from "./Results.styled";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { HideResultsPanelAction, IApplicationState } from "../../store";
import { Icons, Text } from "@sede-enterprise/shell-ds-react-framework";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { CellInfo } from "../../core/types";
import { FetchAuctionResultsAction } from "../../store/Results/ActionCreator";
import { LoadingIndicator } from "../../components/LoadingIndicator/LoadingIndicator";

const Results: React.FC = () => {
  const dispatch = useAppDispatch();

  const calculateMaxHeight = () => {
    return window.innerHeight - 200;
  };

  const calculateMaxWidth = () => {
    return window.innerWidth;
  };

  const [maxHeight, setMaxHeight] = useState(calculateMaxHeight());
  const [maxWidth, _] = useState(calculateMaxWidth());
  const auctionProductResults = useSelector((state: IApplicationState) => state.results.auctionProductResults);
  const auctionResultsName = useSelector((state: IApplicationState) => state.results.auctionResultsName);
  const identification = useSelector((state: IApplicationState) => state.results.identification);
  const isLoading = useSelector((state: IApplicationState) => state.results.isLoading);

  const rowData = useMemo(() => {
    const productResults = (auctionProductResults || []).sort((a, b) => {
      const timeA = a.productHour.split('-')[0];
      const timeB = b.productHour.split('-')[0];
      
      const dateA = new Date(`1970-01-01 ${timeA}`);
      const dateB = new Date(`1970-01-01 ${timeB}`);
      
      return dateA.getTime() - dateB.getTime(); // ascending order
    });
    return productResults;
  }, [auctionProductResults]);

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(calculateMaxHeight());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onClose = () => {
    return dispatch(HideResultsPanelAction());
  };

  useEffect(() => {
    if (identification) {
      dispatch(FetchAuctionResultsAction(identification));
    }
  }, [identification]);

  const renderValue = (value: any) => {
    return <div>{value}</div>;
  };

  const renderProductHours = (value: any) => {
    return <div>{value}</div>;
  };

  const resultDetailsColumns = () => [
    {
      header: "Time",
      dataIndex: "productHour",
      accessorKey: "productHour",
      width: 120,
      cell: (info: CellInfo) => renderProductHours(info.getValue()),
    },
    {
      header: "Clearing Price",
      dataIndex: "auctionPrice",
      accessorKey: "auctionPrice",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Capacity (MW)",
      dataIndex: "allocatedCapacity",
      accessorKey: "allocatedCapacity",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue()),
    }
  ];

  const resultsTable = () => {
    return (
      <TableStyled
        data-testid="results-table"
        data={rowData}
        columns={resultDetailsColumns()}
        size="small"
        stickyHeader={true}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
      />
    );
  };

  const resultsTableContainer = () => {
    return (<TableContainer>
      {
        isLoading
        ? <LoadingIndicator />
        : resultsTable()
      }
    </TableContainer>)
  }

  const resultsPending = () => {
    return (
      <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%' }}>
        <Text bold={true}>
          Awaiting results...
        </Text>
      </div>
    );
  }

  const exchangeHasPublishedResults =
    rowData &&
      rowData.length > 0 &&
      rowData[0].productHour &&
      rowData[0].productHour.length > 0;

  return (
    <div data-testid="result">
      <ResultPanelStyle>
        <ResultHeader>
          <Text bold={true} size="large">
            {auctionResultsName}
          </Text>
          <Icons.Cross className="crossIcon" onClick={onClose} />
        </ResultHeader>
        <ResultRowContainer></ResultRowContainer>
        {
          exchangeHasPublishedResults
          ? resultsTableContainer()
          : resultsPending()
        }
        <ResultFooter></ResultFooter>
      </ResultPanelStyle>
    </div>
  );
};

export default Results;